module.exports = __webpack_public_path__ + "img/dec14_01.5add69cb.jpeg";